import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { REPORT_TYPE } from '../../../../../constants/dropdown';
import { CollectionSummaryReport } from './CollectionSummaryReport';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BASE_URL } from '../../../../../utils';


const initialSchemeAllotmentDataObj = { data: [], loading: false };

export const IndoorCollectionRegisterReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
      report: 'Bill Wise Collection'
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  // console.log('HELLLLLLO USERSSSS', user);
  
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/inpatient-management/indoor-collection-register?refId=${JSON.stringify({ from_date: watch('from_date'), to_date: watch('to_date') })}`)
     console.log("API url data", response);
     if (response.data.success) {
     const filteredData = response?.data?.data?.indoorServiceData?.data || [];
      if (filteredData.length > 0) {
        console.log("Conditional Data", filteredData);

        const fileName = `Indoor_Collection_Register_Report_${JSON.stringify(watch('from_date'))}_to_${JSON.stringify(watch('to_date'))}`;
        
        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Bill Date': formatDate(item?.date),
          'Type': item?.service_items?.map(service => service.type).join(", "), // Access each service item type
          'Patient Name': (`${item?.patient?.name_suffix} ${item?.patient?.first_name} ${item?.patient?.last_name}`),
          'Uhid No.': item?.patient?.uhid,
          'Adm No': item?.ipd_no,
          'Pay Mode': item?.pay_mode,
          'Consultant': item?.patient?.consultant?.name,
          'Services': item?.combinedServiceDetails?.map(service => service.service_name).join(","),// Access each service item type
          'Panel': item?.patient?.sponsor?.name,
          'Bill Amount': item?.total_amt,
          'Dis Amount': item?.disc_amt,
          'Read Amount': item?.total_recd,
          'Bal Amount': item?.balance_amt,
          'User Name': item?.createdBy,
          
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      }else{
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
               IPD Collection Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    ) } >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={handleExcelReport} >
                  Download Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <CollectionSummaryReport />
      </Dialog>
    </>
  );
};
